import React, { useState } from "react";
import { Interweave } from "interweave";

// import JS files

// import others files

const Content = ({ paragraphs }) => {
  return (
    <>
      <div className="">
        {paragraphs.map((it, ind) => {
          if (
            it.image_file == "EMPTY" &&
            it.is_title == false &&
            it.is_link == false
          ) {
            return [
              <div
                className="my-4 text-myblacks-300 text-center news-content"
                style={{ lineHeight: 2 }}
              >
                <Interweave content={it.text} />
              </div>,
            ];
          } else if (it.is_title && it.image_file == "EMPTY") {
            return [
              <div className="text-center my-8">
                <div className="text-xl font-bold px-2 border-x-4 border-myreds-100 inline-block">
                  <span>{it.text}</span>
                </div>
              </div>,
            ];
          } else if (it.is_link && it.image_file == "EMPTY") {
            return [
              <div className="my-4 flex justify-end cursor-pointer  text-myblues-300">
                <p>
                  <a target="_blank" href={it.text}>
                    {it.text}
                  </a>
                </p>
              </div>,
            ];
          } else {
            return [
              <div className="flex justify-center my-4">
                <img src={it.image_file} className="rounded-lg" />
              </div>,
            ];
          }
        })}
      </div>
    </>
  );
};

export default Content;
